import React from 'react'
import PropTypes from 'prop-types'
import ForgotPasswordForm from 'components/Auth/ForgotPasswordForm'

const ForgotPasswordPage = ({ location }) => (
  <ForgotPasswordForm
    defaultEmail={location.state && location.state.email}
  />
)

ForgotPasswordPage.propTypes = {
  location: PropTypes.object.isRequired
}

export default ForgotPasswordPage
